import { Badge } from '@/components/ui';
import { MetricCard } from './MetricCard';

/**
 * Stat card: today-so-far vs yesterday-up-to-the-same-wall-clock-minute.
 * Apples-to-apples comparison (NOT today-so-far vs full-yesterday — that
 * would print -80% every morning and look insane). The big number is
 * today's running click total; the badge below is the % delta vs the
 * matching slice of yesterday.
 *
 * Both the org analytics page and the per-link analytics page show this
 * card, so it lives in /components for reuse.
 */
export function TodayVsYesterdayCard({
  delta,
}: {
  delta: { today: number; yesterdaySameTime: number };
}) {
  const { today, yesterdaySameTime: yest } = delta;
  let badgeText: string;
  let badgeTone: 'secondary' | 'error' | 'neutral' = 'neutral';
  if (yest === 0 && today === 0) {
    badgeText = 'No traffic yet today';
  } else if (yest === 0) {
    // Today has traffic, yesterday had none at this point — pure "new
    // momentum" rather than a meaningless ∞% delta.
    badgeText = 'New vs yesterday';
    badgeTone = 'secondary';
  } else {
    const pct = ((today - yest) / yest) * 100;
    const sign = pct >= 0 ? '+' : '';
    badgeText = `${sign}${pct.toFixed(0)}% vs yesterday`;
    badgeTone = pct >= 0 ? 'secondary' : 'error';
  }
  return (
    <MetricCard
      label="Today vs yesterday"
      value={today.toLocaleString()}
      badge={<Badge tone={badgeTone}>{badgeText}</Badge>}
      meta={
        <span title="Yesterday up to the same wall-clock minute (UTC)">
          {yest.toLocaleString()} by this point yesterday
        </span>
      }
    />
  );
}
